import { useCallback } from "react";
import ArrowBack from "~icons/material-symbols/arrow-back";
import Close from "~icons/material-symbols/close";
import { css } from "../../styled-system/css";
import { t } from "../libs/i18n";
import { closeMiniAppWindow, sdk } from "../libs/sdk";

type Props = {
  title: string;
  theme?: "dark";
  onClickBack?: () => void;
};

export default function Header({ title, theme, onClickBack }: Props) {
  const onClickClose = useCallback(() => {
    void closeMiniAppWindow(sdk).catch((e) => {
      console.error(e);
      window.alert(
        t(
          "ミニアプリを閉じることができません。アプリケーションを再起動してください。",
        ),
      );
    });
  }, []);

  return (
    <header
      className={css({
        bg: theme === "dark" ? "#3D4756" : "background.background",
        h: "calc(48px + env(safe-area-inset-top, 0px))",
        pt: "env(safe-area-inset-top, 0px)",
        boxSizing: "border-box",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        position: "fixed",
        zIndex: 100,
        top: 0,
        left: 0,
        right: 0,
        color: theme === "dark" ? "white" : "text.primary",
      })}
    >
      {onClickBack && (
        <button
          type="button"
          className={css({
            position: "absolute",
            left: 0,
            top: "env(safe-area-inset-top, 0px)",
            height: "48px",
            width: "48px",
            fontSize: "18px",
            pl: "16px",
            textAlign: "center",
          })}
          onClick={onClickBack}
        >
          <ArrowBack className={css({ mx: "auto" })} />
        </button>
      )}
      <h1
        className={css({
          color: "text.primary",
          fontWeight: "500",
          fontSize: "18px",
          // 左右のボタン(各48px)に潜り込ませない
          maxWidth: "calc(100% - 96px)",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          textAlign: "center",
        })}
      >
        {title}
      </h1>

      <button
        type="button"
        className={css({
          position: "absolute",
          right: 0,
          top: "env(safe-area-inset-top, 0px)",
          height: "48px",
          width: "48px",
          pr: "16px",
          textAlign: "center",
          fontSize: "18px",
        })}
        onClick={onClickClose}
      >
        <Close className={css({ mx: "auto" })} />
      </button>
    </header>
  );
}
